























































import { mask } from 'vue-the-mask';
import Vue from 'vue';
import { Donation } from '@/interfaces/donation/donation';
import { Donor } from '@/interfaces/donation/donor';
import DonorFormComponent from '@/components/donor/DonorFormComponent.vue';
import BasicDonorFormComponent from '@/components/donor/BasicDonorFormComponent.vue';
import { RequestSession } from '@/interfaces/requestSession';
import { isMemoryGift, isContribution } from '@/classes/DonationType';
import { stepV1, stepV2 } from '@/enums/donationStepOrder';
import { DonationGuideVersion } from '@/enums/donationGuideVersion';
import DonationStepperFlowMixin from '@/mixins/donationStepperFlowMixin';

export default Vue.extend({
  components: {
    DonorFormComponent,
    BasicDonorFormComponent,
  },
  directives: {
    mask,
  },
  mixins: [DonationStepperFlowMixin],
  props: {
    showPreviousButton: {
      type: Boolean,
      default: true,
    },
    compact: Boolean,
  },
  data() {
    return {
      valid: true,
      manualInput: false,
      showError: false,
      pep: false,
      donor: {
        address: {
          address1: '',
          address2: '',
          address3: '',
          city: '',
          country: '',
          postcode: '',
        },
        email: '',
        firstname: '',
        surname: '',
        socialSecurityNumber: '',
        token: '',
      } as Donor,
    };
  },
  computed: {
    steps(): typeof stepV1 | typeof stepV2 {
      return this.getDonationStepFlowVersion() == DonationGuideVersion.V1 ? stepV1 : stepV2;
    },
    donation(): Donation {
      return this.$store.state.donation;
    },
    isMemoryGift() {
      return this.donation && isMemoryGift(this.donation.donationType.type);
    },
    isContribution() {
      return this.donation && isContribution(this.donation.donationType.type);
    },
    requestSession(): RequestSession {
      return this.$store.state.requestSession;
    },
  },
  methods: {
    prev() {
      this.$emit('prev');
    },
    next() {
      if (!this.$refs.form.validate()) {
        // TODO: Break out and reuse for other form steps
        for (var i = 0; i < this.$refs.form.$children.length; i++) {
          const child = this.$refs.form.$children[i];
          if (child.valid === false) {
            this.$vuetify.goTo(child, { offset: 100 });
          }
        }
        return;
      }
      if (!this.showError || this.manualInput) {
        if (this.manualInput) {
          this.donor.token = '';
        }
        let donation: Donation = this.donation;
        donation.donor = this.donor;
        this.$store.commit('updateDonation', donation);
        this.$emit('nextStep');
      }
    },
  },
});
